import { GetAllExternalFlightBookingRequestsState } from './getAllExternalFlightBookingRequests.types'

const initialState: GetAllExternalFlightBookingRequestsState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
